import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';

const Layout = ({ children }) => (
    <div className="appLayout">
        <Navbar />
        <main className="mainContent">{children}</main>
        <Footer />
    </div>
);

export default Layout;
